module.exports = __webpack_public_path__ + "static/media/cancer-ico-grey.d8e83fa1.svg";